"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var EurekaMath_exports = {};
__export(EurekaMath_exports, {
  default: () => EurekaMath_default
});
module.exports = __toCommonJS(EurekaMath_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 200 200",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0 8C0 3.58173 3.58172 0 8 0H192C196.418 0 200 3.58172 200 8V192C200 196.418 196.418 200 192 200H8C3.58173 200 0 196.418 0 192V8Z",
      fill: "#7EBB52"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.8255 86.0129V67H39.4165V86.6421C39.4165 94.2839 46.1115 98.6374 53.7348 98.6374C61.3601 98.6374 68.0541 94.2839 68.0541 86.6421V67H57.8405V86.059C57.8405 88.7692 55.5922 89.8343 53.834 89.8343C52.0747 89.8343 49.8255 88.7692 49.8255 86.0129ZM28.2675 102.136H18.6885L16 133H25.8735L26.6601 123.565C26.7502 122.328 26.7384 121.202 26.656 119.795H26.7521C27.241 121.437 27.8281 122.89 28.561 124.292L33.106 133H37.4081L41.9521 124.292C42.7345 122.791 43.2235 121.536 43.7124 119.795H43.8085C43.7124 121.437 43.8085 122.89 43.9067 124.195L44.6406 133H54.9534L52.2153 102.136H43.4188L38.1885 112.25C37.4557 113.696 36.5264 115.732 35.9413 117.423H35.8927C35.256 115.732 34.2802 113.65 33.5453 112.25L28.2675 102.136ZM87.0692 133L75.8281 102.136H67.0803L55.8392 133H65.4667L67.2756 127.097H74.9971L76.7574 133H87.0692ZM109.752 102.136V110.457H101.884V133H91.4725V110.407H83.5577V102.136H109.752ZM122.415 113.116V102.136H112.004V133H122.415V122.018H130.431V133H140.841V102.136H130.431V113.116H122.415ZM146.776 102.15C148.808 102.15 150.37 103.696 150.37 105.623C150.37 107.594 148.808 109.139 146.776 109.139C144.764 109.139 143.16 107.594 143.16 105.623C143.16 103.696 144.764 102.15 146.776 102.15ZM35.9898 67V75.271H27.0951V78.1747H34.2295V86.6892H27.0951V89.5888H37.162V97.8639H16.9787V67H35.9898ZM95.9183 77.0615C95.9183 71.3054 91.4694 67 85.1662 67H71.7751V97.8639H81.6951V87.125H82.0859L88.9783 97.8639H101.05L91.8612 84.5601C94.1094 83.3978 95.9183 80.1575 95.9183 77.0615ZM120.604 67V75.271H111.711V78.1747H118.844V86.6892H111.711V89.5888H121.776V97.8639H101.593V67H120.604ZM134.441 78.6596V67H124.03V97.8639H134.441V87.1751H134.49L140.745 97.8639H152.767L143.188 82.3838L152.23 67H141.089L134.49 78.6596H134.441ZM172.761 67L184 97.8639H173.69L171.929 91.9604H164.209L162.403 97.8639H152.772L164.012 67H172.761ZM71.04 113.218H71.1362C71.284 113.989 71.4793 114.663 71.6747 115.294L72.8469 119.356H69.3769L70.5987 115.294C70.7159 114.946 70.7981 114.546 70.8771 114.115L71.04 113.218ZM168.072 78.0767H167.971L167.81 78.9767C167.731 79.4088 167.649 79.8093 167.532 80.1568L166.312 84.2197H169.779L168.608 80.1568C168.412 79.5255 168.215 78.8512 168.072 78.0767ZM81.695 75.0797H83.7955C84.9221 75.0797 86.1925 75.8041 86.1925 77.307C86.1925 78.8039 84.9221 79.5273 83.7955 79.5273H81.695V75.0797ZM146.776 102.85C145.214 102.85 144.059 104.099 144.059 105.623C144.059 107.169 145.214 108.399 146.797 108.399C148.338 108.399 149.472 107.169 149.472 105.645C149.472 104.099 148.338 102.85 146.776 102.85ZM146.754 103.863C147.417 103.863 147.717 103.97 147.973 104.118C148.166 104.266 148.316 104.541 148.316 104.88C148.316 105.261 148.017 105.558 147.588 105.685V105.727C147.931 105.854 148.124 106.108 148.231 106.575L148.304 106.916C148.371 107.205 148.423 107.348 148.487 107.442H147.61C147.523 107.34 147.464 107.11 147.387 106.81C147.37 106.742 147.351 106.67 147.331 106.596C147.268 106.214 147.053 106.045 146.604 106.045H146.22V107.442H145.407V103.97C145.728 103.906 146.176 103.863 146.754 103.863ZM146.69 104.436C146.476 104.436 146.326 104.458 146.24 104.48V105.475H146.626C147.075 105.475 147.439 105.326 147.439 104.967C147.439 104.648 147.204 104.436 146.69 104.436Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8 1H192V-1H8V1ZM199 8V192H201V8H199ZM192 199H8V201H192V199ZM1 192V8H-1V192H1ZM8 199C4.13401 199 1 195.866 1 192H-1C-1 196.971 3.02944 201 8 201V199ZM199 192C199 195.866 195.866 199 192 199V201C196.971 201 201 196.971 201 192H199ZM192 1C195.866 1 199 4.13401 199 8H201C201 3.02944 196.971 -1 192 -1V1ZM8 -1C3.02944 -1 -1 3.02944 -1 8H1C1 4.13401 4.13401 1 8 1V-1Z",
      fill: "#7A7562"
    }
  )
);
const SvgEurekaMath = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var EurekaMath_default = SvgEurekaMath;
